/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import Vue from 'vue'

const state = {
  listas: [],
  filtro: {
    mostrarRejeitadasEExpiradas: true,
    status: null,
    cobrancaEnvio: {
      dataInicio: null,
      dataFim: null,
    },
    validade: {},
    palavraChave: null,
    geraContrato: null,
    filtroDataPesquisa: 0,
  },
}

const getters = {
  listas: state_ => state.listas,
  filtro: state_ => state.filtro,
}

const actions = {
  setListas({ commit }, listas) {
    commit('SET_LISTA_PROPOSTAS', listas)
  },
  adicionarPendente({ commit }, proposta) {
    commit('ADICIONAR_LISTA_PENDENTE', proposta)
  },
  adicionarChecklist({ commit }, proposta) {
    commit('ADICIONAR_LISTA_CHECKLIST', proposta)
  },
  adicionarNegociacao({ commit }, proposta) {
    commit('ADICIONAR_LISTA_NEGOCIACAO', proposta)
  },
  removerProposta({ commit }, payload) {
    commit('REMOVER_PROPOSTA_LISTA', payload)
  },
  mudarColunaCartaoEnvio({ commit }, proposta) {
    commit('MUDAR_COLUNA_PROPOSTA_ENVIO', proposta)
  },
  mudarColunaStatus({ commit }, payload) {
    commit('MUDAR_COLUNA_PROPOSTA_STATUS', payload)
  },
  atualizarPropostaColuna({ commit }, payload) {
    commit('ATUALIZAR_PROPOSTA_LISTA', payload)
  },
  adicionarEtiqueta({ commit }, payload) {
    commit('ADICIONAR_ETIQUETA', payload)
  },
  removerEtiquetasPropostas({ commit }, etiqueta) {
    commit('REMOVER_ETIQUETAS_PROPOSTAS', etiqueta)
  },
  adicionadoTramite({ commit }, payload) {
    commit('ADICIONADO_TRAMITE', payload)
  },
  adicionadoObservacao({ commit }, payload) {
    commit('ADICIONADO_OBSERVACAO', payload)
  },
  adicionarContratanteCapa({ commit }, payload) {
    commit('ADICIONAR_CONTRATANTE_CAPA', payload)
  },
  limparFiltro({ commit }) {
    commit('LIMPAR_FILTRO')
  },
  adicionarNovasPropostas({ commit }, payload) {
    commit('ADICIONAR_NOVAS_PROPOSTAS', payload)
  },
}

const mutations = {
  SET_LISTA_PROPOSTAS(state_, listas) {
    Vue.set(state_, 'listas', listas)
  },
  ADICIONAR_LISTA_PENDENTE(state_, proposta) {
    state_.listas.pendente.propostas.push(proposta)
    state_.listas.pendente.total += 1
    state_.listas.pendente.valorTotal += proposta.valor
  },
  ADICIONAR_LISTA_CHECKLIST(state_, proposta) {
    state_.listas.checklist.propostas.push(proposta)
    state_.listas.checklist.total += 1
    state_.listas.checklist.valorTotal += proposta.valor
  },
  ADICIONAR_LISTA_NEGOCIACAO(state_, proposta) {
    state_.listas.negociacao.propostas.push(proposta)
    state_.listas.negociacao.total += 1
    state_.listas.negociacao.valorTotal += proposta.valor
  },
  REMOVER_PROPOSTA_LISTA(state_, payload) {
    if (payload.statusProposta === 'pendenteenvio') {
      const index = state_.listas.pendente.propostas.findIndex(find => find.id === payload.propostaId)
      const result = state_.listas.pendente.propostas.splice(index, 1)
      state_.listas.pendente.total -= 1
      state_.listas.pendente.valorTotal -= result[0].valor
    } else if (payload.statusProposta === 'negociacao' || payload.statusProposta === 'naoaprovada') {
      const index = state_.listas.negociacao.propostas.findIndex(find => find.id === payload.propostaId)
      const result = state_.listas.negociacao.propostas.splice(index, 1)
      state_.listas.negociacao.total -= 1
      state_.listas.negociacao.valorTotal -= result[0].valor
    } else if (payload.statusProposta === 'aprovada') {
      const index = state_.listas.aprovadas.propostas.findIndex(find => find.id === payload.propostaId)
      const result = state_.listas.aprovadas.propostas.splice(index, 1)
      state_.listas.aprovadas.total -= 1
      state_.listas.aprovadas.valorTotal -= result[0].valor
    } else if (payload.statusProposta === 'rejeitado') {
      const index = state_.listas.rejeitadas.propostas.findIndex(find => find.id === payload.propostaId)
      const result = state_.listas.rejeitadas.propostas.splice(index, 1)
      state_.listas.rejeitadas.total -= 1
      state_.listas.rejeitadas.valorTotal -= result[0].valor
    } else if (payload.statusProposta === 'expirada') {
      const index = state_.listas.expiradas.propostas.findIndex(find => find.id === payload.propostaId)
      const result = state_.listas.expiradas.propostas.splice(index, 1)
      state_.listas.expiradas.total -= 1
      state_.listas.expiradas.valorTotal -= result[0].valor
    } else if (payload.statusProposta === 'checklist') {
      const index = state_.listas.checklist.propostas.findIndex(find => find.id === payload.propostaId)
      const result = state_.listas.checklist.propostas.splice(index, 1)
      state_.listas.checklist.total -= 1
      state_.listas.checklist.valorTotal -= result[0].valor
    }
  },
  MUDAR_COLUNA_PROPOSTA_ENVIO(state_, proposta) {
    const index = state_.listas.pendente.propostas.findIndex(find => find.id === proposta.id)
    const result = state_.listas.pendente.propostas.splice(index, 1)
    state_.listas.pendente.total -= 1
    state_.listas.pendente.valorTotal -= result[0].valor
    state_.listas.negociacao.propostas.push(proposta)
    state_.listas.negociacao.total += 1
    state_.listas.negociacao.valorTotal += proposta.valor
  },
  MUDAR_COLUNA_PROPOSTA_STATUS(state_, payload) {
    if (payload.colunaDe === 'negociacao' || payload.colunaDe === 'naoaprovada') {
      const index = state_.listas.negociacao.propostas.findIndex(find => find.id === payload.propostaCartao.id)
      state_.listas.negociacao.propostas.splice(index, 1)
      state_.listas.negociacao.total -= 1
      state_.listas.negociacao.valorTotal -= payload.propostaCartao.valor
      if (payload.colunaPara === 4) {
        state_.listas.rejeitadas.propostas.push(payload.propostaCartao)
        state_.listas.rejeitadas.total += 1
        state_.listas.rejeitadas.valorTotal += payload.propostaCartao.valor
      } else if (payload.colunaPara === 3) {
        state_.listas.aprovadas.propostas.push(payload.propostaCartao)
        state_.listas.aprovadas.total += 1
        state_.listas.aprovadas.valorTotal += payload.propostaCartao.valor
      } else if (payload.colunaPara === 2 || payload.colunaPara === 7) {
        state_.listas.negociacao.propostas.splice(index, 0, payload.propostaCartao)
        state_.listas.negociacao.total += 1
        state_.listas.negociacao.valorTotal += payload.propostaCartao.valor
      }
    } else if (payload.colunaDe === 6) {
      if (payload.colunaPara !== 6) {
        const indexCheck = state_.listas.checklist.propostas.findIndex(find => find.id === payload.propostaCartao.id)
        state_.listas.checklist.propostas.splice(indexCheck, 1)
        state_.listas.checklist.total -= 1
        state_.listas.checklist.valorTotal -= payload.propostaCartao.valor
      }
      if (payload.colunaPara === 1) {
        state.listas.pendente.propostas.push(payload.propostaCartao)
        state.listas.pendente.total += 1
        state.listas.pendente.valorTotal += payload.propostaCartao.valor
      }
    }
  },
  ATUALIZAR_PROPOSTA_LISTA(state_, payload) {
    if (payload.colunaDe === 1) {
      const index = state_.listas.pendente.propostas.findIndex(find => find.id === payload.propostaCartao.id)
      state_.listas.pendente.propostas.splice(index, 1)
      state_.listas.pendente.propostas.splice(index, 0, payload.propostaCartao)
    } else if (payload.colunaDe === 2 || payload.colunaDe === 7) {
      const index = state_.listas.negociacao.propostas.findIndex(find => find.id === payload.propostaCartao.id)
      state_.listas.negociacao.propostas.splice(index, 1)
      state_.listas.negociacao.propostas.splice(index, 0, payload.propostaCartao)
    } else if (payload.colunaDe === 3) {
      const index = state_.listas.aprovadas.propostas.findIndex(find => find.id === payload.propostaCartao.id)
      state_.listas.aprovadas.propostas.splice(index, 1)
      state_.listas.aprovadas.propostas.splice(index, 0, payload.propostaCartao)
    } else if (payload.colunaDe === 6) {
      const index = state_.listas.checklist.propostas.findIndex(find => find.id === payload.propostaCartao.id)
      state_.listas.checklist.propostas.splice(index, 1)
      state_.listas.checklist.propostas.splice(index, 0, payload.propostaCartao)
    }
  },
  ADICIONADO_TRAMITE(state_, payload) {
    const checklist = state_.listas.checklist.propostas.find(find => find.id === payload.id)
    if (checklist) {
      checklist.tramite = payload.existe
      const index = state_.listas.checklist.propostas.findIndex(find => find.id === payload.id)
      state_.listas.checklist.propostas.splice(index, 1)
      state_.listas.checklist.propostas.splice(index, 0, checklist)
    }
    const pendente = state_.listas.pendente.propostas.find(find => find.id === payload.id)
    if (pendente) {
      pendente.tramite = payload.existe
      const index = state_.listas.pendente.propostas.findIndex(find => find.id === payload.id)
      state_.listas.pendente.propostas.splice(index, 1)
      state_.listas.pendente.propostas.splice(index, 0, pendente)
    }
    const negociacao = state_.listas.negociacao.propostas.find(find => find.id === payload.id)
    if (negociacao) {
      negociacao.tramite = payload.existe
      const index = state_.listas.negociacao.propostas.findIndex(find => find.id === payload.id)
      state_.listas.negociacao.propostas.splice(index, 1)
      state_.listas.negociacao.propostas.splice(index, 0, negociacao)
    }
  },
  ADICIONADO_OBSERVACAO(state_, payload) {
    const checklist = state_.listas.checklist.propostas.find(find => find.id === payload.id)
    if (checklist) {
      checklist.observacao = payload.existe
      const index = state_.listas.checklist.propostas.findIndex(find => find.id === payload.id)
      state_.listas.checklist.propostas.splice(index, 1)
      state_.listas.checklist.propostas.splice(index, 0, checklist)
    }

    const pendente = state_.listas.pendente.propostas.find(find => find.id === payload.id)
    if (pendente) {
      pendente.observacao = payload.existe
      const index = state_.listas.pendente.propostas.findIndex(find => find.id === payload.id)
      state_.listas.pendente.propostas.splice(index, 1)
      state_.listas.pendente.propostas.splice(index, 0, pendente)
    }

    const negociacao = state_.listas.negociacao.propostas.find(find => find.id === payload.id)
    if (negociacao) {
      negociacao.observacao = payload.existe
      const index = state_.listas.negociacao.propostas.findIndex(find => find.id === payload.id)
      state_.listas.negociacao.propostas.splice(index, 1)
      state_.listas.negociacao.propostas.splice(index, 0, negociacao)
    }

    const aprovada = state_.listas.aprovadas.propostas.find(find => find.id === payload.id)
    if (aprovada) {
      aprovada.observacao = payload.existe
      const index = state_.listas.aprovadas.propostas.findIndex(find => find.id === payload.id)
      state_.listas.aprovadas.propostas.splice(index, 1)
      state_.listas.aprovadas.propostas.splice(index, 0, aprovada)
    }

    const finalizada = state_.listas.finalizadas.propostas.find(find => find.id === payload.id)
    if (finalizada) {
      finalizada.observacao = payload.existe
      const index = state_.listas.finalizadas.propostas.findIndex(find => find.id === payload.id)
      state_.listas.finalizadas.propostas.splice(index, 1)
      state_.listas.finalizadas.propostas.splice(index, 0, finalizada)
    }

    const rejeitada = state_.listas.rejeitadas.propostas.find(find => find.id === payload.id)
    if (rejeitada) {
      rejeitada.observacao = payload.existe
      const index = state_.listas.rejeitadas.propostas.findIndex(find => find.id === payload.id)
      state_.listas.rejeitadas.propostas.splice(index, 1)
      state_.listas.rejeitadas.propostas.splice(index, 0, rejeitada)
    }

    const expirada = state_.listas.expiradas.propostas.find(find => find.id === payload.id)
    if (expirada) {
      expirada.observacao = payload.existe
      const index = state_.listas.expiradas.propostas.findIndex(find => find.id === payload.id)
      state_.listas.expiradas.propostas.splice(index, 1)
      state_.listas.expiradas.propostas.splice(index, 0, expirada)
    }
  },
  ADICIONAR_ETIQUETA(state_, payload) {
    const pendente = state.listas.pendente.propostas.find(prop => prop.id === payload.propostaId)
    if (pendente) {
      pendente.etiquetas.push(payload.etiqueta)
      return
    }

    const checklist = state.listas.checklist.propostas.find(prop => prop.id === payload.propostaId)
    if (checklist) {
      checklist.etiquetas.push(payload.etiqueta)
      return
    }

    const negociacao = state.listas.negociacao.propostas.find(prop => prop.id === payload.propostaId)
    if (negociacao) {
      negociacao.etiquetas.push(payload.etiqueta)
      return
    }

    const aprovada = state.listas.aprovadas.propostas.find(prop => prop.id === payload.propostaId)
    if (aprovada) {
      aprovada.etiquetas.push(payload.etiqueta)
      return
    }

    const rejeitada = state.listas.rejeitadas.propostas.find(prop => prop.id === payload.propostaId)
    if (rejeitada) {
      rejeitada.etiquetas.push(payload.etiqueta)
      return
    }

    const expirada = state.listas.expiradas.propostas.find(prop => prop.id === payload.propostaId)
    if (expirada) {
      expirada.etiquetas.push(payload.etiqueta)
    }

    const finalizada = state.listas.finalizadas.propostas.find(prop => prop.id === payload.propostaId)
    if (finalizada) {
      finalizada.etiquetas.push(payload.etiqueta)
    }
  },
  REMOVER_ETIQUETAS_PROPOSTAS(state_, etiqueta) {
    state_.listas.pendente.propostas.forEach((proposta, i) => {
      const index = proposta.etiquetas.findIndex(fil => fil.id === etiqueta.id)
      if (index >= 0) {
        proposta.etiquetas.splice(index, 1)
        Vue.set(state_.listas.pendente.propostas[i], 'etiquetas', proposta.etiquetas)
      }
    })
    state_.listas.negociacao.propostas.forEach((proposta, i) => {
      const index = proposta.etiquetas.findIndex(fil => fil.id === etiqueta.id)
      if (index >= 0) {
        proposta.etiquetas.splice(index, 1)
        Vue.set(state_.listas.negociacao.propostas[i], 'etiquetas', proposta.etiquetas)
      }
    })
    state_.listas.aprovadas.propostas.forEach((proposta, i) => {
      const index = proposta.etiquetas.findIndex(fil => fil.id === etiqueta.id)
      if (index >= 0) {
        proposta.etiquetas.splice(index, 1)
        Vue.set(state_.listas.aprovadas.propostas[i], 'etiquetas', proposta.etiquetas)
      }
    })
    state_.listas.rejeitadas.propostas.forEach((proposta, i) => {
      const index = proposta.etiquetas.findIndex(fin => fin.id === etiqueta.id)
      if (index >= 0) {
        proposta.etiquetas.splice(index, 1)
        Vue.set(state_.listas.rejeitadas.propostas[i], 'etiquetas', proposta.etiquetas)
      }
    })
    state_.listas.expiradas.propostas.forEach((proposta, i) => {
      const index = proposta.etiquetas.findIndex(fin => fin.id === etiqueta.id)
      if (index >= 0) {
        proposta.etiquetas.splice(index, 1)
        Vue.set(state_.listas.expiradas.propostas[i], 'etiquetas', proposta.etiquetas)
      }
    })
    state_.listas.checklist.propostas.forEach((proposta, i) => {
      const index = proposta.etiquetas.findIndex(fin => fin.id === etiqueta.id)
      if (index >= 0) {
        proposta.etiquetas.splice(index, 1)
        Vue.set(state_.listas.checklist.propostas[i], 'etiquetas', proposta.etiquetas)
      }
    })
    state_.listas.finalizadas.propostas.forEach((proposta, i) => {
      const index = proposta.etiquetas.findIndex(fin => fin.id === etiqueta.id)
      if (index >= 0) {
        proposta.etiquetas.splice(index, 1)
        Vue.set(state_.listas.finalizadas.propostas[i], 'etiquetas', proposta.etiquetas)
      }
    })
  },
  ADICIONAR_CONTRATANTE_CAPA(state_, payload) {
    const negociacao = state_.listas.negociacao.propostas.find(prop => prop.id === payload.propostaId)
    if (negociacao) {
      negociacao.contratantes.push(payload.contratante)
      return
    }

    const aprovada = state_.listas.finalizadas.propostas.find(prop => prop.id === payload.propostaId)
    if (aprovada) {
      aprovada.contratantes.push(payload.contratante)
      return
    }

    const rejeitada = state_.listas.rejeitadas.propostas.find(prop => prop.id === payload.propostaId)
    if (rejeitada) {
      rejeitada.contratantes.push(payload.contratante)
      return
    }

    const expirada = state_.listas.expiradas.propostas.find(prop => prop.id === payload.propostaId)
    if (expirada) {
      expirada.contratantes.push(payload.contratante)
    }

    const finalizada = state_.listas.finalizadas.propostas.find(prop => prop.id === payload.propostaId)
    if (finalizada) {
      finalizada.contratantes.push(payload.contratante)
    }
  },
  LIMPAR_FILTRO(state_) {
    Vue.set(state_, 'filtro', {
      filtroDataPesquisa: 0,
      cobrancaEnvio: {},
      gerentes: null,
      validade: {},
      pessoas: null,
      propostas: null,
      status: null,
      etiquetas: null,
      geraContrato: null,
    })
  },
  ADICIONAR_NOVAS_PROPOSTAS(state_, payload) {
    if (payload.coluna === 1) {
      payload.propostas.forEach(proposta => {
        state_.listas.checklist.propostas.push(proposta)
      })
    } else if (payload.coluna === 2) {
      payload.propostas.forEach(proposta => {
        state_.listas.pendente.propostas.push(proposta)
      })
    } else if (payload.coluna === 3) {
      payload.propostas.forEach(proposta => {
        state_.listas.negociacao.propostas.push(proposta)
      })
    } else if (payload.coluna === 4) {
      payload.propostas.forEach(proposta => {
        state_.listas.aprovadas.propostas.push(proposta)
      })
    } else if (payload.coluna === 5) {
      payload.propostas.forEach(proposta => {
        state_.listas.finalizadas.propostas.push(proposta)
      })
    } else if (payload.coluna === 6) {
      payload.propostas.forEach(proposta => {
        state_.listas.rejeitadas.propostas.push(proposta)
      })
    } else if (payload.coluna === 7) {
      payload.propostas.forEach(proposta => {
        state_.listas.expiradas.propostas.push(proposta)
      })
    }
  },
}

export default {
  namespaced: true,
  getters,
  actions,
  mutations,
  state: () => state,
}
